import Vue from "vue";
import App from "./App.vue";
import router from "./router";
Vue.config.productionTip = false;
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper);
import "./utils/perm.js";
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
import { Toast } from "vant";
Vue.use(Toast);
import defaultImg from "./directives/defaultImg";
Vue.use(defaultImg);
import { getShareInfo } from "@/utils/share.js";
getShareInfo()
new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
